import { paths } from './paths';

interface FromState {
  from?: { pathname?: unknown; search?: unknown; hash?: unknown };
}

/**
 * Where to go after signing in: the page ProtectedRoute bounced the user from, or the dashboard.
 * Only same-app paths are accepted.
 */
export function redirectTarget(state: unknown): string {
  const from = (state as FromState | null)?.from;
  const pathname = from?.pathname;
  if (
    typeof pathname !== 'string' ||
    !pathname.startsWith('/') ||
    pathname.startsWith('//') ||
    pathname === paths.login ||
    pathname === paths.logout
  ) {
    return paths.dashboard;
  }
  const search = typeof from?.search === 'string' ? from.search : '';
  const hash = typeof from?.hash === 'string' ? from.hash : '';
  return `${pathname}${search}${hash}`;
}
